"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getRules = exports.getRules = function getRules(state) {
  return state.rules.rulesData;
};

var getruleErrors = exports.getruleErrors = function getruleErrors(state) {
  return state.rules.ruleErrors;
};


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/dear-diary/lib/store/rules/selectors/index.js
// module id = 3424
// module chunks = 2